import axios from "axios";
import Vue from "vue";

export default {
  state: () => ({
    customer: {},
    loggedInCustomer: false,
    selectedCustomer: {
      bloodType: { id: null },
      profession: { id: null },
      user: { taxAdministration: { id: null }, nationalityCountryId: 1, gender: null },
      educationStatus: { id: null },
      tariffCardNumber: null,
    },
    isThisAnUpdateCustomer: false,
    isFromCreatePageForCustomer: false,
  }),

  mutations: {
    setCustomer(state, customer) {
      state.customer = customer;
    },
    // setLoggedInCustomer(state, loggedInCustomer){
    //   state.loggedInCustomer = loggedInCustomer
    // },
    setSelectedCustomer(state, selectedCustomer) {
      Vue.set(state, "selectedCustomer", selectedCustomer);
    },
    setIsThisAnUpdateCustomer(state, isThisAnUpdateCustomer) {
      Vue.set(state, "isThisAnUpdateCustomer", isThisAnUpdateCustomer);
    },
    setIsFromCreatePageForCustomer(state, isFromCreatePageForCustomer) {
      Vue.set(state, "isFromCreatePageForCustomer", isFromCreatePageForCustomer);
    },
    setDefaultCustomerModule(state, isFromCreatePageForCustomer) {
      Vue.set(state, "customer", {});
      Vue.set(state, "loggedInCustomer", false);
      Vue.set(state, "selectedCustomer", {
        bloodType: {},
        profession: {},
        user: { taxAdministration: {}, nationalityCountryId: 1 },
        educationStatus: {},
      });
      Vue.set(state, "isThisAnUpdateCustomer", false);
      Vue.set(state, "isFromCreatePageForCustomer", false);
    },
  },

  actions: {
    saveCustomerInformation: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadNationalities: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/countries/entity").then((response) => {
        return response.data;
      });
    },
    loadNationalitiesFromTmsCdn: (context, request) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/countries.json").then((response) => {
        return response.data;
      });
    },

    updateCustomerInformation: (context, request) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/customers", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    // customerLogin: (context, request) => {
    //   return axios
    //   .post(context.getters.getTmsServiceUrl + "/customer/login", request)
    //   .then((response) => {
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     return err.response;
    //   });
    // },

    // loadCustomers: (context) => {
    //   return axios
    //   .get(context.getters.getMcServiceUrl + "/customers/entity")
    //   .then((response) => {
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     return err.response;
    //   });
    // },
    loadCustomer: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/customers/entity/" + request.id)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadCustomerFilterList: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers/search", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    deleteCustomer: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers/" + request.id + "/delete", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    deleteDraftCustomer: (context, customer) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/customers/draft/" + customer.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    loadBloodTypes: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blood-types/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadProfessions: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/professions/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEducationStatuses: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/education-statuses/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadTaxAdministrations: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/tax-administrations/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCustomerLog: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/logs" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCustomerSearchOne: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/customers/search-one", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserSearchOne: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/users/search-one", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCustomerSearchGetInfo: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers/search-one-get-info", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCustomerSearchGetInfoAllUser: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers/search-one-get-info-all-users", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCustomerSessions: (context, userId) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/customers/" + userId + "/sessions")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    logoutCustomerSession: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/customers/sessions/logout", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getCustomer: (state) => {
      return state.customer;
    },
    // loggedInCustomer: state => {
    //   return state.loggedInCustomer;
    // },
    getSelectedCustomer: (state) => {
      return state.selectedCustomer;
    },
    getIsThisAnUpdateCustomer: (state) => {
      return state.isThisAnUpdateCustomer;
    },
    getIsFromCreatePageForCustomer: (state) => {
      return state.isFromCreatePageForCustomer;
    },
  },
};
